// extracted by mini-css-extract-plugin
module.exports = {"formitemRow":"sendProductTable_formitemRow__2c6pc"};